import { PointDetailsPermissions } from "@/features/collection_home/types";
import { getMetricShortLabel, MetricKey } from "../charts/common/utils";

export type MetricOption = {
  value: MetricKey;
  label: string;
  shortLabel: string;
  title: string;
  description: string;
  unit: "%" | "$";
};

const METRIC_DEFS: { value: MetricKey; key: string; unit: "%" | "$"; ttip?: boolean }[] = [
  { value: "avg_damage_mtd", key: "mvar", unit: "%" },
  { value: "productivity_loss", key: "productivityLoss", unit: "%" },
  { value: "avg_failure_mtd", key: "failureProbability", unit: "%" },
  { value: "ttip", key: "ttip", unit: "$", ttip: true },
];

export const buildMetricOptions = (
  t: (key: string) => string,
  showTtip: boolean,
  isPointLevel = false
): MetricOption[] =>
  METRIC_DEFS.filter((d) => !d.ttip || showTtip).map((d) => ({
    value: d.value,
    unit: d.unit,
    label: t(`charts.${d.key}.label`),
    shortLabel: getMetricShortLabel(d.value, isPointLevel),
    title: t(`charts.${d.key}.title`),
    description: t(`charts.${d.key}.description`),
  }));

export const filterMetricsByPermissions = (
  options: MetricOption[],
  permissions?: PointDetailsPermissions
): MetricOption[] => {
  if (!permissions) return options;
  return options.filter((o) => {
    switch (o.value) {
      case "avg_damage_mtd":
        return permissions.showMvar;
      case "productivity_loss":
        return permissions.showProductivityLoss;
      case "avg_failure_mtd":
        return permissions.showFailureProbability;
      case "ttip":
        return permissions.showTtip;
      default:
        return true;
    }
  });
};
